// The URL fragment the app was opened with, captured at module load — before
// React renders and before an auth or release-notes redirect can rewrite the
// address. A fragment is never sent to the server and does not survive those
// redirects, so a page that identifies its target with one (the COT portfolio
// root) has to recover it from here after the round-trip.
const bootPathname = window.location.pathname;
const bootHash = window.location.hash;

let spent = false;

// Handed out once, and only to the page it was aimed at, so returning to that
// page later in the same session starts from a clean selection.
export const takeBootHash = (pathname: string): string => {
    if (spent || pathname.toLowerCase() !== bootPathname.toLowerCase()) {
        return "";
    }
    spent = true;
    return bootHash;
};
